export const saveOffer = (items) => ({
  type: "SAVE_OFFER",
  items,
});

export const clearOffer = (items) => ({
  type: "CLEAR_OFFER",
  items,
});
